import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Badge } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
  FiPackage
} from "react-icons/fi";

const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();

const SolicitudReempaque = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [trackingInput, setTrackingInput] = useState("");

  const [formData, setFormData] = useState({
    estado: "",
    faltanPaquetes: false,
    paquetes: [], 
  });

  const [editingId, setEditingId] = useState(null);
  const itemsPerPageOptions = [5, 10, 20, 50];

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  const fetchData = async () => {
    try {
      const token = cookies.get("token");
      const response = await fetch(`${API_HOST}/reempaques?export=true`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          API: "457896",
        },
      });
      const result = await response.json();
      
      const items = Array.isArray(result) ? result : result.data || [];
      setData(items);
      setFilteredData(items);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = () => {
    const filtered = data.filter(
      (item) =>
        item.idSolicitud?.toString().includes(searchTerm) ||
        item.cliente?.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.estado?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.estado) {
      newErrors.estado = "El estado es requerido";
    }

    if (formData.faltanPaquetes && (formData.estado === "Aprobada" || formData.estado === "Denegada")) {
      newErrors.estado = "No puedes Aprobar o Denegar una solicitud si aún 'Faltan Paquetes'. Desmarca la casilla primero.";
    }

    if (formData.paquetes.length === 0) {
      newErrors.paquetes = "Debe asignar al menos un paquete válido.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item) => {
    setFormData({
      estado: item.estado || "Pendiente",
      faltanPaquetes: item.faltanPaquetes || false,
      paquetes: item.paquetes ? [...item.paquetes] : [], 
    });
    setEditingId(item.idSolicitud);
    setTrackingInput("");
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    let nuevoEstado = formData.estado;
    if (name === 'faltanPaquetes' && checked && (nuevoEstado === "Aprobada" || nuevoEstado === "Denegada")) {
       nuevoEstado = "Pendiente";
    }

    setFormData({ 
        ...formData, 
        estado: name === 'faltanPaquetes' ? nuevoEstado : (name === 'estado' ? value : formData.estado),
        [name]: type === 'checkbox' ? checked : value 
    });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };

  const handleAddPackage = async () => {
    if (!trackingInput.trim()) return;

    try {
      const token = cookies.get("token");
      const response = await fetch(`${API_HOST}/paquetes/verificar-disponibilidad/${trackingInput.trim()}`, {
        method: "GET", 
        headers: { 
          Authorization: `Bearer ${token}`, 
          API: "457896" 
        }
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || "El paquete no está disponible o no existe");
      }
      
      const resData = await response.json();
      // Corrección para soportar si la respuesta viene envuelta en .data
      const paquete = resData.data || resData;

      if (!paquete || !paquete.idPaquete) {
        throw new Error("El paquete no contiene un ID válido estructurado por el servidor.");
      }

      if (formData.paquetes.find(p => p.idPaquete === paquete.idPaquete || p.tracking === paquete.tracking)) {
        Swal.fire("Atención", "El paquete ya está en la lista", "info");
        return;
      }

      setFormData({
        ...formData,
        paquetes: [...formData.paquetes, { idPaquete: paquete.idPaquete, tracking: paquete.tracking || trackingInput.trim() }]
      });
      setTrackingInput(""); 
      
      if (errors.paquetes) setErrors({ ...errors, paquetes: null });

    } catch (error) {
      Swal.fire("Error", error.message, "error");
    }
  };

  const handleRemovePackage = (idPaquete) => {
    setFormData({
      ...formData,
      paquetes: formData.paquetes.filter(p => p.idPaquete !== idPaquete)
    });
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      Swal.fire("Atención", "Por favor corrige los errores en el formulario", "warning");
      return;
    }

    // CORRECCIÓN PRINCIPAL: Mapeamos asegurando enviar tanto idPaquete como tracking
    const paquetesParaEnviar = formData.paquetes.map((p) => ({
      idPaquete: p.idPaquete,
      tracking: p.tracking
    }));

    const dataToSubmit = {
      estado: formData.estado,
      faltanPaquetes: formData.faltanPaquetes,
      paquetes: paquetesParaEnviar 
    };

    try {
      const bearertoken = cookies.get("token");
      const response = await fetch(`${API_HOST}/reempaques/${editingId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al actualizar la solicitud");
      }

      Swal.fire("Éxito", "Solicitud actualizada correctamente", "success");
      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire("Error", error.message || "Hubo un problema en la operación", "error");
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¡No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/reempaques/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });
          Swal.fire("¡Eliminado!", "La solicitud ha sido eliminada.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el registro", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  const getBadgeColor = (estado) => {
    switch(estado) {
      case 'Aprobada': return 'success';
      case 'Denegada': return 'danger';
      case 'Completada': return 'info';
      default: return 'warning'; 
    }
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Solicitudes de Reempaque</h5>
          </div>

          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por ID solicitud, Cliente o Estado...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select value={itemsPerPage} onChange={handleItemsPerPageChange} style={{ width: "80px" }} size='sm'>
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Cliente</th>
                  <th className='border-top-0'>Cant. Paquetes</th>
                  <th className='border-top-0'>Estado</th>
                  <th className='border-top-0'>¿Completa?</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.idSolicitud}>
                    <td className='text-muted fw-bold'>#{item.idSolicitud}</td>
                    <td>{item.cliente?.nombre || `ID: ${item.idCliente}`}</td>
                    <td>
                        <FiPackage className="me-1 text-secondary"/>
                        {item.paquetes ? item.paquetes.length : 0}
                    </td>
                    <td>
                      <Badge bg={getBadgeColor(item.estado)}>{item.estado}</Badge>
                    </td>
                    <td>
                      {!item.faltanPaquetes ? (
                        <Badge bg="success">Sí (Cerrada)</Badge>
                      ) : (
                        <Badge bg="warning" text="dark">No (En espera)</Badge>
                      )}
                    </td>
                    <td className='text-end'>
                      <Button variant='outline-secondary' onClick={() => handleShowModal(item)} className='me-2' title='Editar' size='sm'>
                        <FiEdit />
                      </Button>
                      <Button variant='outline-danger' onClick={() => handleDelete(item.idSolicitud)} className='me-2' title='Eliminar' size='sm'>
                        <FiTrash />
                      </Button>
                      <Button variant='outline-primary' onClick={() => handleView(item)} title='Ver detalles' size='sm'>
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
                {displayedData.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-4">
                      No se encontraron solicitudes.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {filteredData.length > 0 && (
            <div className='d-flex justify-content-between align-items-center mt-3'>
              <div className='text-muted small'>
                Mostrando {displayedData.length} de {filteredData.length} registros
              </div>
              <ReactPaginate
                previousLabel={<FiChevronLeft size={14} />}
                nextLabel={<FiChevronRight size={14} />}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                breakLabel='...'
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
              />
            </div>
          )}
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>Modificar Solicitud #{editingId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-3'>
              <Form.Check
                type="switch"
                id="faltan-paquetes-switch"
                label="¿El cliente indicó que FALTAN paquetes?"
                name="faltanPaquetes"
                checked={formData.faltanPaquetes}
                onChange={handleChange}
                className="text-muted"
              />
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Estado de la Solicitud</Form.Label>
              <Form.Select
                name='estado'
                value={formData.estado}
                onChange={handleChange}
                isInvalid={!!errors.estado}
                className='border'
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Aprobada" disabled={formData.faltanPaquetes}>Aprobada</option>
                <option value="Denegada" disabled={formData.faltanPaquetes}>Denegada</option>
                <option value="Completada">Completada</option>
              </Form.Select>
              <Form.Control.Feedback type='invalid'>
                {errors.estado}
              </Form.Control.Feedback>
              {formData.faltanPaquetes && (
                <Form.Text className="text-warning">
                  Debes desmarcar "Faltan paquetes" para poder Aprobar o Denegar.
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Gestionar Paquetes a Reempacar (Tracking)</Form.Label>
              <div className="d-flex mb-2">
                <Form.Control
                  type='text'
                  value={trackingInput}
                  onChange={(e) => setTrackingInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddPackage();
                    }
                  }}
                  placeholder='Ej: TRK12345 y presiona Enter'
                  isInvalid={!!errors.paquetes}
                />
                {/* CORRECCIÓN: type="button" explícito */}
                <Button type="button" variant="secondary" onClick={handleAddPackage} className="ms-2">
                  Agregar
                </Button>
              </div>
              
              <div className={`border p-3 rounded ${errors.paquetes ? 'border-danger' : 'bg-light'}`}>
                {formData.paquetes.length > 0 ? (
                  formData.paquetes.map((p) => (
                    <Badge 
                      bg="secondary" 
                      className="me-2 p-2 mb-2 border" 
                      key={p.idPaquete} 
                      style={{ fontSize: '13px', fontWeight: 'normal' }}
                    >
                      {p.tracking || `ID: ${p.idPaquete}`} 
                      <span 
                        role="button" 
                        className="ms-2 text-white-50" 
                        onClick={() => handleRemovePackage(p.idPaquete)}
                        style={{ cursor: 'pointer' }}
                        title="Quitar paquete"
                      >
                        ✕
                      </span>
                    </Badge>
                  ))
                ) : (
                  <small className="text-muted">No hay paquetes asignados a esta solicitud.</small>
                )}
              </div>
              {errors.paquetes && (
                <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                  {errors.paquetes}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='light' onClick={handleCloseModal}>Cancelar</Button>
          <Button variant='primary' onClick={handleSubmit}>Guardar Cambios</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showViewModal} onHide={handleCloseViewModal} centered size="lg">
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-secondary' />
            Detalles de Solicitud #{selectedItem?.idSolicitud}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div className="row">
              <div className='col-md-6 mb-3'>
                <h6 className='text-muted mb-2 border-bottom pb-2'>Información General</h6>
                <div className='ps-2'>
                  <p className='mb-2'><span className='fw-bold'>Cliente:</span> {selectedItem.cliente?.nombre || selectedItem.idCliente}</p>
                  <p className='mb-2'><span className='fw-bold'>Estado:</span> <Badge bg={getBadgeColor(selectedItem.estado)}>{selectedItem.estado}</Badge></p>
                  <p className='mb-2'>
                    <span className='fw-bold'>Status Paquetes:</span>{" "}
                    {!selectedItem.faltanPaquetes ? <span className="text-success fw-bold">Completa</span> : <span className="text-warning fw-bold">Faltan por llegar</span>}
                  </p>
                  <p className='mb-2'><span className='fw-bold'>Creado:</span> {formatDate(selectedItem.createdAt)}</p>
                </div>
              </div>

              <div className='col-md-12 mt-3'>
                <h6 className='text-muted mb-3 border-bottom pb-2'>Paquetes Asignados a esta Solicitud</h6>
                {selectedItem.paquetes && selectedItem.paquetes.length > 0 ? (
                  <div className="table-responsive">
                    <Table size="sm" bordered hover>
                      <thead className="table-light">
                        <tr>
                          <th>ID Paquete</th>
                          <th>Tracking</th>
                          <th>Estado Actual</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItem.paquetes.map((pkg) => (
                          <tr key={pkg.idPaquete}>
                            <td>{pkg.idPaquete}</td>
                            <td className="fw-bold">{pkg.tracking || "N/A"}</td>
                            <td><Badge bg="secondary">{pkg.estado}</Badge></td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <div className="alert alert-light border text-center text-muted">
                    No hay paquetes vinculados a esta solicitud.
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='light' onClick={handleCloseViewModal}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SolicitudReempaque;